import { render } from "./PokemonCard.vue?vue&type=template&id=7aea61d2&scoped=true"
import script from "./PokemonCard.vue?vue&type=script&lang=js"
export * from "./PokemonCard.vue?vue&type=script&lang=js"

import "./PokemonCard.vue?vue&type=style&index=0&id=7aea61d2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aea61d2"]])

export default __exports__